import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2, ArrowLeft, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      signIn(data.token, data.user);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative grid place-items-center px-6">
      <img
        src="https://images.unsplash.com/photo-1758630737361-ca7532fb5e7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
        alt="Modern print office"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-ink/70" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white mb-5 transition-colors"><ArrowLeft size={15} /> Back home</Link>
        <div className="bg-white/95 backdrop-blur-xl rounded-2xl border border-white/20 shadow-2xl p-8 sm:p-10 animate-fade-up">
          <Logo />
          <div className="flex items-center gap-2 mt-8 text-brand"><Lock size={16} /><span className="uppercase text-xs tracking-[0.2em] font-medium">Staff & admin</span></div>
          <h1 className="font-heading font-black text-3xl text-ink mt-2">Management console</h1>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="block uppercase text-xs tracking-[0.18em] font-medium text-slate-500 mb-2">Email</label>
              <input type="email" required data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand" />
            </div>
            <div>
              <label className="block uppercase text-xs tracking-[0.18em] font-medium text-slate-500 mb-2">Password</label>
              <input type="password" required data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand" />
            </div>
            {error && <p className="text-sm text-red-600 font-medium" data-testid="admin-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-button"
              className="w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-white font-semibold py-3.5 rounded-lg transition-colors flex items-center justify-center gap-2">
              {loading ? <><Loader2 className="animate-spin" size={18} /> Signing in…</> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
